import { FC, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import axios from 'axios'
import { errorToast, successToast } from '../../../../../../../_metronic/helpers/components/Toaster'

type Props = {
    id: any
    data: any
    close: () => void
}

const BeneficirariesModal: FC<Props> = ({ id, data, close }) => {
    return createPortal(
        <div className="modal fade show d-block" style={{
            backgroundColor: 'rgba(0,0,0,0.5)',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 999999
        }}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Beneficiaries</h5>
                        <button type="button" className="btn-close" onClick={close}></button>
                    </div>
                    <div className="modal-body">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px', border: '1px solid #e0e0e0', borderRadius: '8px', marginBottom: '16px' }}>
                            <img
                                src="https://via.placeholder.com/60"
                                alt="beneficiary"
                                style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover' }}
                            />
                            <div style={{ flex: 1 }}>
                                <p style={{ margin: '0', fontSize: '16px', fontWeight: '600', color: '#333' }}>John Doe</p>
                                <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#999' }}>Issued: 2025-11-16</p>
                            </div>
                            <span className="badge badge-light-success">Active</span>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px', border: '1px solid #e0e0e0', borderRadius: '8px', marginBottom: '16px' }}>
                            <img
                                src="https://via.placeholder.com/60"
                                alt="beneficiary"
                                style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover' }}
                            />
                            <div style={{ flex: 1 }}>
                                <p style={{ margin: '0', fontSize: '16px', fontWeight: '600', color: '#333' }}>Jane Smith</p>
                                <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#999' }}>Issued: 2025-11-15</p>
                            </div>
                            <span className="badge badge-light-warning">Pending</span>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px', border: '1px solid #e0e0e0', borderRadius: '8px' }}>
                            <img
                                src="https://via.placeholder.com/60"
                                alt="beneficiary"
                                style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover' }}
                            />
                            <div style={{ flex: 1 }}>
                                <p style={{ margin: '0', fontSize: '16px', fontWeight: '600', color: '#333' }}>Mike Johnson</p>
                                <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#999' }}>Issued: 2025-11-14</p>
                            </div>
                            <span className="badge badge-light-danger">Expired</span>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={close}>Close</button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    )
}

export { BeneficirariesModal }